import { render, staticRenderFns } from "./lazy-tasks.vue?vue&type=template&id=f718a520&scoped=true&"
import script from "./lazy-tasks.vue?vue&type=script&lang=js&"
export * from "./lazy-tasks.vue?vue&type=script&lang=js&"
import style0 from "./lazy-tasks.vue?vue&type=style&index=0&id=f718a520&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f718a520",
  null
  
)

export default component.exports